module.exports = ".container {\n  background-color: #399cc7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .container h1, .container h3 {\n    color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found.component.scss
// module id = ./src/app/not-found.component.scss
// module chunks = main